// 6 thẻ KPI đầu trang. Markup và class name giữ y nguyên bản innerHTML cũ để
// src/styles.css không phải sửa gì.
import type { Totals, Rates } from "../domain.ts";

type Card = {
  label: string;
  icon: string;
  value: number;
  /** Tỷ lệ chuyển đổi so với bậc liền trước; thẻ đầu funnel không có. */
  badge?: string;
  sub: string;
};

export type KpiCardsProps = { totals: Totals; rates: Rates };

export function KpiCards({ totals: t, rates: r }: KpiCardsProps) {
  // 6 thẻ = đúng 6 cột số của list "Recruitment Funnel Weekly",
  // badge = tỷ lệ chuyển đổi so với bậc liền trước.
  const cards: Card[] = [
    { label: "Candidates Contacted", icon: "👥", value: t.contacted, sub: "Funnel start" },
    { label: "Candidates Responses", icon: "💬", value: t.responses, badge: `${r.responseRate}%`, sub: "Response Rate" },
    { label: "Applications", icon: "📄", value: t.applications, badge: `${r.applicationRate}%`, sub: "Of Responses" },
    { label: "Interviews", icon: "💼", value: t.interviews, badge: `${r.interviewRate}%`, sub: "Of Applications" },
    { label: "Offers", icon: "🏅", value: t.offers, badge: `${r.offerRate}%`, sub: "Of Interviews" },
    { label: "Hires", icon: "🎉", value: t.hires, badge: `${r.hireRate}%`, sub: "Of Offers" },
  ];

  return (
    <>
      {cards.map((c) => (
        <div className="kpi-card" key={c.label}>
          <div className="k-head">
            <span>{c.label.toUpperCase()}</span>
            <span>{c.icon}</span>
          </div>
          <div className="k-value">{c.value.toLocaleString("en-US")}</div>
          <div className="k-sub">
            {c.badge ? <span className="k-badge">{c.badge}</span> : null}
            <span>{c.sub}</span>
          </div>
        </div>
      ))}
    </>
  );
}
